module.exports = __webpack_public_path__ + "static/img/bg_record.4738fbf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/ibroadcast/bg_record.jpg
// module id = 848
// module chunks = 0